/* eslint-disable */
import React, { useEffect, useState, useMemo } from "react";
import { getData, postData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";
import { MaterialReactTable } from "material-react-table";
import { MenuItem, Box } from "@mui/material";
import { assetImages } from "constants";
import ActionLogHeader from "./Header/ActionLogHeader";
import ActionLogFilterPopup from "./Popup/ActionLogFilterPopup";
import ActionLogDetailsPopup from "./Popup/ActionLogDetailsPopup";
import { useTranslation } from "react-i18next";

const ActionLogBody = () => {
  const todayValue = new Date().toISOString().split("T")[0];

  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const { t, i18n } = useTranslation();

  const [actionLogList, setActionLogList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  // ✅ Filter states
  const [filterActionStartDate, setFilterActionStartDate] = useState("");
  const [filterActionEndDate, setFilterActionEndDate] = useState("");
  const [filterActionLogUsers, setfilterActionLogUsers] = useState([]);

  const [rowSelection, setRowSelection] = useState({});
  const [selectedActionLogIds, setSelectedActionLogIds] = useState([]);
  const [selectedActionLog, setSelectedActionLog] = useState(null);

  const getAllActionLogs = async () => {
    setRowSelection({});
    setSelectedActionLogIds([]);
    try {
      setIsLoading(true);

      let requestUrl =
        url.API_BASE_URL + url.API_GET_ACTION_LOGS;

      // ✅ Check if any filter is active
      const hasDateFilter =
        filterActionStartDate !== "" || filterActionEndDate !== "";
      const hasUserFilter = filterActionLogUsers.length > 0;

      if (!hasDateFilter && !hasUserFilter) {
        // no filter then send today
        requestUrl += `&filterdates=${todayValue}`;
      } else {
        // ✅ Date filter build
        if (filterActionStartDate && filterActionEndDate) {
          // both date range then send by comma
          requestUrl += `&filterdates=${filterActionStartDate},${filterActionEndDate}`;
        } else if (filterActionStartDate) {
          // only start date → single date
          requestUrl += `&filterdates=${filterActionStartDate}`;
        } else if (filterActionEndDate) {
          // only end date → single date
          requestUrl += `&filterdates=${filterActionEndDate}`;
        }

        // ✅ User filter
        if (hasUserFilter) {
          requestUrl += `&filterusers=${filterActionLogUsers.join(",")}`;
        }
      }

      console.log("Request URL:", requestUrl);

      const response = await getData(requestUrl);

      console.log("Action Log Response:", response);
      
      setIsLoading(false);

      if (response.status) {
        setActionLogList(response.data);
      }
    } catch (error) {
      console.log(error.message);
      setIsLoading(false);
    }
  };

  // ✅ Reset all filters
  const resetFilterData = () => {
    setFilterActionStartDate("");
    setFilterActionEndDate("");
    setfilterActionLogUsers([]);
    setRowSelection({});
    setSelectedActionLogIds([]);
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "#",
        header: t("Actions"),
        size: 70,
        Cell: ({ row }) => {
          return (
            <button
              className="action_btn_mui"
              data-bs-toggle="offcanvas"
              data-bs-target="#actionLogDetails"
              aria-controls="actionLogDetails"
              onClick={() => {
                setSelectedActionLog(row.original);
              }}
            >
              <span className="d-block material-symbols-outlined horz_icon">
                more_horiz
              </span>
            </button>
          );
        },
        enableColumnActions: false,
        enableColumnDragging: false,
        enableSorting: false,
      },
      { accessorKey: "fullname", header: t("User") },
      { accessorKey: "email", header: t("Email") },
      { accessorKey: "module", header: t("Module") },
      { accessorKey: "action", header: t("Action") },
      {
        accessorKey: "ipaddress",
        header: t("IP Address"),
        Cell: ({ cell }) => {
          const ip = cell.getValue();
          return ip ? ip.replace(/^::ffff:/i, "") : "";
        },
      },
      { accessorKey: "systeminfo", header: t("System Information") },
      { accessorKey: "actiondateformated", header: t("Date") },
      { accessorKey: "url", header: t("Url") },
    ],
    [i18n.language],
  );

  // ✅ Initial load
  useEffect(() => {
    getAllActionLogs();
  }, []);

  // ✅ If filter change then re-fetch
  useEffect(() => {
    getAllActionLogs();
  }, [filterActionStartDate, filterActionEndDate, filterActionLogUsers]);

  useEffect(() => {
    const selectedIdsArray = Object.keys(rowSelection).filter(
      (key) => rowSelection[key],
    );
    setSelectedActionLogIds(
      selectedIdsArray.length > 0 ? selectedIdsArray : [],
    );
  }, [rowSelection]);

  if (userInfo.role.slug === "ADMIN" || userInfo.role.slug === "SUPER_ADMIN") {
    return (
      <div id="content_wrapper">
        <section className="crm-wrapper bg-white pb-5">
          <div className="container-fluid px-lg-5">
            <ActionLogHeader reloadList={resetFilterData} />

            {isLoading ? (
              <div className="placeholder-glow d-flex flex-column gap-4">
                <span className="placeholder placeholder-lg bg-secondary col-12"></span>
                <span className="placeholder placeholder-lg bg-secondary col-8"></span>
                <span className="placeholder placeholder-lg bg-secondary col-4"></span>
              </div>
            ) : (
              <div className="table-wrapper">
                <MaterialReactTable
                  columns={columns}
                  data={actionLogList}
                  enableGrouping
                  muiTableContainerProps={{ sx: { maxHeight: "60vh" } }}
                  enableStickyHeader
                />
              </div>
            )}
          </div>

          <ActionLogFilterPopup
            setFilterActionStartDate={setFilterActionStartDate}
            setFilterActionEndDate={setFilterActionEndDate}
            setfilterActionLogUsers={setfilterActionLogUsers}
          />

          <ActionLogDetailsPopup actionLogData={selectedActionLog} />
        </section>
      </div>
    );
  } else {
    return (
      <div id="content_wrapper">
        <section className="crm-wrapper bg-white pb-5">
          <div className="empty_access text-center">
            <div className="empty_pic mb-4">
              <img src={assetImages.emptyVector} alt="" />
            </div>
            <div className="empty_text">
              <p className="fs-lg text-gray fw-semibold mb-4">
                {t("Sorry....! You don't have privilege to see this content")}
              </p>
            </div>
          </div>
        </section>
      </div>
    );
  }
};

export default ActionLogBody;
